module.exports = __webpack_public_path__ + "img/1008.999778be.gif";